import React       from 'react';
import ReactDom    from 'react-dom';
// -------------------------------------------------------

class InputCustomSlackItems extends React.Component {
  update() {
    this.props.update_ev.bind(this)(this.item.value);
  }
  
  render() {
    let data = this.props.data;
    
    try {
      return (
        <div className="selectbox">
          <select ref={(input) => { this.item = input }} onChange={this.update.bind(this)} defaultValue={data.default}>
            { this.props.base.management.slack_channels.map((d, key) => {
              return <option key={key} value={d.channel_id}>{d.channel_name} (@{d.channel_id})</option>
             })}
          </select>
        </div>
      );
    } catch(e) {
      return null;
    }
  }
}
// -------------------------------------------------------

// レンダリング処理
export default InputCustomSlackItems;